<template>
  <div class="stripe-banner-component">
    <span class="exclamation">!</span>
    <span class="banner-content">
      There was a problem with your payment method.
      <button class="button-reset text-white" data-test="update-payment-button" @click="showUpdatePaymentModal">
        Update it now</button> to continue accessing content.
    </span>
  </div>
</template>

<script>
export default {
  methods: {
    showUpdatePaymentModal() {
      this.$store.commit('ui/setProfileModalShown', 'updatePaymentInfoModal');
    },
  },
};
</script>

<style lang="scss" scoped>
.stripe-banner-component {
  background-color: #dc3416;
  color: #ffffff;
  height: 100%;
  font-weight: $semi-bold;
  font-size: rem-calc(12);
  text-align: center;
  padding: rem-calc(18) rem-calc(8);

  .text-white {
    color: #ffffff;
    font-weight: $semi-bold;
    text-decoration: underline;
  }

  @include breakpoint(small) {
    padding-top: rem-calc(24);
  }

  .exclamation {
    font-weight: bold;
    border: 1px solid #ffffff;
    display: inline-block;
    height: rem-calc(18);
    width: rem-calc(18);
    border-radius: 100%;
    margin-right: rem-calc(12);
    font-size: initial;
    vertical-align: middle;
  }

  .banner-content {
    display: inline-block;
    vertical-align: middle;
    max-width: 80%;
    line-height: 1.25;

    .profile-link {
      color: inherit;
      text-decoration: underline;
      font-weight: bold;
    }
  }
}
</style>
